



















import TabLayout, { ITab } from "@/layouts/TabLayout.vue";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { IReference, Reference } from "@/models/reference.entity";
import { IReport } from "@/models/report.entity";
import { ITag } from "@/models/tag.entity";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { TagModule } from "@/store/modules/tag.store";
import DocumentTable from "@/views/sign/DocumentTable.vue";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import { ActionEnum } from "@/store/enum/authActionEnum";

type ITagTabs = ITab & {
  tag?: ITag;
};

@Component({
  components: {
    TabLayout,
    DocumentTable
  },
  filters: {}
})
export default class PartnerReportDetailDocument extends mixins(PermissionMixin) {
  @Ref("documentTable")
  documentTable!: DocumentTable;

  @Prop()
  report!: IReport;

  readonly allTab = {
    id: "all",
    value: $t("sign.latest"),
    icon: "mdi-clock-time-nine-outline",
    tag: undefined
  };

  isLoading = false;

  tabs: ITagTabs[] = [];

  activeTab: ITagTabs | null = null;

  get ref(): IReference {
    return new Reference({ refId: this.report.id, refType: BackendResourceEnum.REPORT });
  }

  async mounted() {
    this.activeTab = this.allTab;
    this.isLoading = true;

    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.TAG, this.report.partnerId)) {
      TagModule.setFilters([
        new PageFilterElement({
          key: "resources",
          value: BackendResourceEnum.DOCUMENT,
          operation: PageFilterOperationEnum.EQUAL
        })
      ]);
      await TagModule.fetchFirstPage({
        partnerId: this.report.partnerId
      });
    }

    this.tabs.push(this.allTab);
    for (const tag of TagModule.filteredAndSorted) {
      this.tabs.push({
        id: tag.id,
        value: tag.value,
        icon: tag.icon || "mdi-tag-outline",
        tag
      });
    }

    this.isLoading = false;
  }

  setActiveTab(tab: ITagTabs) {
    this.activeTab = null;
    this.$nextTick(() => {
      this.activeTab = tab;
    });
  }
}
